import { Container } from '@mui/material';
import { GoalReport } from 'components/templates';
import React from 'react';
import { useParams } from 'react-router-dom';

export const GoalReportView = () => {
  const { patientGoalId: id } = useParams();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <GoalReport id={id !== undefined ? Number(id) : 0} />
    </Container>
  );
};
